import React, { FC } from "react";
import Modal from "../global/Modal/Modal";
import SimpleButton from "../global/SimpleButton/SimpleButton";
interface CustomDeleteProps {
  isModalOpenDelete: boolean;
  title: string;
  setIsModalOpenDelete: (value: boolean) => void;
  deleteHandler: () => void;
}
const CustomDelete: FC<CustomDeleteProps> = ({
  isModalOpenDelete,
  title,
  deleteHandler,
  setIsModalOpenDelete,
}) => {
  return (
    <Modal visible={isModalOpenDelete} setVisible={setIsModalOpenDelete} title={title}>
      <p className="text-center">آیا از حذف این مورد اطمینان دارید؟</p>
      <div className="flex w-full justify-center gap-4 mt-5">
        <SimpleButton
          type="submit"
          text="خیر"
          className="full-lightTomato-btn w-28 "
          handelClick={() => setIsModalOpenDelete(false)}
        />
        <SimpleButton
          type="submit"
          text="بله"
          className="full-tomato-btn w-28 "
          handelClick={() => deleteHandler()}
        />
      </div>
    </Modal>
  );
};

export default CustomDelete;
